import { QueryString } from "@/app/shared/filter";

export class RegionQueryString extends QueryString {
    public override get isNoValue(): boolean {
        return this._value === '';
    }
    override _fieldModelName: string = "region";
    override _fieldName: string = "region";
    constructor(value: any = "", sort: number = 0) {
        super();
        this._value = value;
    }
}